import { mainSiteUrl } from '@/mocks/categories';

export default function CtaSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[600px] overflow-hidden">
      {/* Background Image */}
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20tech%20office%20interior%20with%20rows%20of%20desks%20and%20computers%2C%20bright%20natural%20light%20from%20floor%20to%20ceiling%20windows%2C%20green%20plants%20throughout%2C%20collaborative%20workspace%20vibe%2C%20professional%20corporate%20photography%2C%20warm%20daylight%20atmosphere%2C%20wide%20panoramic%20view&width=1800&height=1200&seq=cta-v2-pano-01&orientation=landscape"
        alt="usfansspreadsheet - nowoczesne biuro"
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading="lazy"
      />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-black/50 via-black/30 to-black/40"></div>

      {/* Content - Triangular composition */}
      <div className="relative z-10 w-full h-full max-w-[1400px] mx-auto px-4 md:px-6">
        {/* Top Left - Main Title */}
        <div className="absolute top-[20%] left-6 md:left-20">
          <h2 className="font-heading text-5xl md:text-7xl lg:text-8xl text-white leading-none lowercase">
            usfans
            <br />
            spreadsheet
          </h2>
        </div>

        {/* Bottom Right - Description */}
        <div className="absolute bottom-[25%] right-6 md:right-20 text-right">
          <p className="text-white/90 text-lg md:text-xl font-light leading-relaxed max-w-sm">
            Uzyskaj dostęp do pełnego
            <br />
            rozwiązania już teraz.
          </p>
        </div>

        {/* Bottom Left - CTA Button */}
        <div className="absolute bottom-[20%] left-6 md:left-20">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-7 py-3.5 bg-white text-foreground-900 font-semibold text-sm rounded-full hover:bg-background-50 transition-all whitespace-nowrap cursor-pointer group"
          >
            <span>Otwórz platformę</span>
            <div className="w-7 h-7 flex items-center justify-center rounded-full bg-foreground-900 text-white group-hover:bg-foreground-800 transition-colors">
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}